import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './contratoItemActions';

class ContratoItemForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='id_hospital_convenio'
								component={Select}
								options={this.props.listaConvenio.filter(item => item.id_hospital == this.props.id_hospital)}
								label='Convênio *'
								cols='12 12 6 6'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='id_exame'
								component={Select}
								options={this.props.listaExame}
								label='Exame *'
								cols='12 12 6 6'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>

						<Row>
							<Field
								name='sigla_exame1'
								component={LabelAndInput}
								label='Sigla do Exame'
								cols='6 4 3 2'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='observacao_exame1'
								component={LabelAndInput}
								label='Observação no Exame'
								cols='6 4 3 3'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>

						<Row>
							<Field
								name='sigla_exame2'
								component={LabelAndInput}
								label='Sigla'
								cols='6 4 3 2'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='observacao_exame2'
								component={LabelAndInput}
								label='Observação no Exame'
								cols='6 4 3 3'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>
						<Row>
							
							<Field
								maxWidth={180}
								name='valor'
								component={LabelAndInputNumber}
								label='Valor Normal' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='valor_plantao'
								component={LabelAndInputNumber}
								label='Valor para Plantão' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='percentual_imposto'
								component={LabelAndInputNumber}
								label='Percentual de Imposto' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
								
						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Remover'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

ContratoItemForm = reduxForm({form: 'contratoItemForm', destroyOnUnmount: false})(ContratoItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('contratoItemForm')(state),
	registro: state.contratoItem.registro,
	listaConvenio: state.hospitalConvenio.listaSelect,
	listaExame: state.exame.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoItemForm);
